import {useContext} from "react";
import {Context} from "./installerContext.tsx";

export function useInstallerContext() {
	return useContext(Context);
}
